export interface EstimateCostOfFireWork {
  FireWorkCost: number;
}

export interface FireWorkItem {
  Item: string;
  check: boolean;
  Quantity: number;
  Type: string
}

export interface GetAllFee {
  'Certification Cost': number;
  totalFee: number;
  summary: any[];
}

export interface FireData {
  EstimateCostOfWork: EstimateCostOfFireWork;
  WorkItems: FireWorkItem[];
  getAllFee: GetAllFee;
}

export const fireData: FireData = {
  EstimateCostOfWork: {
    FireWorkCost: 0,
  },
  WorkItems: [
    {
      Item: 'Fire Pump/GPM Type',
      check: false,
      Quantity: 1,
      Type: 'Fire Pump Review And Field Accept'
    },
    {
      Item: 'Alarm Valves/Dry Pipe',
      check: false,
      Quantity: 1,
      Type: 'Fire Alarm Device Changes'
    },
    {
      Item: 'Pre-action Valves',
      check: false,
      Quantity: 1,
      Type: 'Fire Alarm Device Changes'
    },
    {
      Item: 'Sprinkler Heads (Dry and Wet)',
      check: false,
      Quantity: 1,
      Type: 'Sprinkler Heads'
    },
    {
      Item: 'Standpipes',
      check: false,
      Quantity: 1,
      Type: 'Standpipe Risers'
    },

    {
      Item: 'Wet Chemical',
      check: false,
      Quantity: 1,
      Type: 'Pre Engineered System',
    },
    {
      Item: 'Dry Chemical',
      check: false,
      Quantity: 1,
      Type: 'Pre Engineered System',
    },
    {
      Item: 'Carbon dioxide',
      check: false,
      Quantity: 1,
      Type: 'Pre Engineered System',
    },
    {
      Item: 'Foam Suppression',
      check: false,
      Quantity: 1,
      Type: 'Pre Engineered System',
    },
    {
      Item: 'FM200 Suppression',
      check: false,
      Quantity: 1,
      Type: 'Pre Engineered System',
    },
    {
      Item: 'Kitchen Hood Exhaust System',
      check: false,
      Quantity: 1,
      Type: 'Kitchen Hood Exhaust Systems',
    },
    {
      Item: 'Smoke Control System',
      check: false,
      Quantity: 1,
      Type: 'Smoke Control Systems',
    },
    {
      Item: 'Fuel-Fired Appliances - Gas',
      check: false,
      Quantity: 1,
      Type: 'Fuel-Fired Appliances',
    }, {
      Item: 'Fuel-Fired Appliances - Oil',
      check: false,
      Quantity: 1,
      Type: 'Fuel-Fired Appliances',
    }, {
      Item: 'Fuel-Fired Appliances - Solid',
      check: false,
      Quantity: 1,
      Type: 'Fuel-Fired Appliances',
    },
    {
      Item: 'Fireplace Venting/Metal Chimney',
      check: false,
      Quantity: 1,
      Type: '',
    },
  ],
  getAllFee: {
    'Certification Cost': 0,
    totalFee: 0,
    summary: [],
  },
};
